import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { UserService } from '@/service/user.service';
@Injectable({
  providedIn: 'root',
})
export class CompanyOnboardingGuard implements CanActivate {
  constructor(
    private router: Router,
    private http: HttpClient,
    private route: ActivatedRoute,
    private keycloakService: KeycloakService,
    private userService: UserService,
  ) {}

  canActivate(): Observable<boolean> {
    return this.isValidInvitation().pipe(
      map((response) => {
        if (response.success) {
          return true;
        } else {
          this.router.navigate(['']);
          return false;
        }
      }),
      catchError(() => {
        this.router.navigate(['']);
        return of(false);
      }),
    );
  }

  isValidInvitation(): Observable<{
    success: boolean;
  }> {
    const userIsLoggedIn = this.keycloakService.isLoggedIn();
    const hasCompanyRole = this.keycloakService
      .getUserRoles()
      .includes('company');

    // User: Not authenticated
    if (!userIsLoggedIn) {
      return of({ success: true });
    }

    // User: Authenticated but not company
    if (userIsLoggedIn && !hasCompanyRole) {
      return of({ success: true });
    }

    // User: Authenticated and company
    return this.userService.getUserInfoForGuard().pipe(
      map((user) => {
        // User: Not onboarded
        if (!user) {
          this.router.navigate(['/user-onboarding']);
          return { success: false };
        }

        // User: Onboarded but company not set
        if (!user.company) {
          this.router.navigate(['/company-onboarding']);
          return { success: false };
        }

        // Onboarded user and company
        return { success: true };
      }),
      catchError((error) => {
        console.error('Error checking user info:', error);
        this.router.navigate(['/home']);
        return of({ success: false });
      }),
    );
  }
}
